
import { aICompetitionProvidersTypes } from '../enums/aICompetitionProvidersTypes';
import { fetchGetAuth, fetchJson, getUserAllSchoolProperty, postJson } from '../utils/utils';
import { assessmentsActions } from './assessments-slice';

export const initDigitalCuratorship = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { lang } = state.translate;
            const { user, isStudent, userDetails } = state.auth;

            const superVisions = getUserAllSchoolProperty(userDetails, 'supervisionId') || [1];
            const res = await fetchJson(window.config.digitalCuratorship);
            const digitalCuratorshipProvider = aICompetitionProvidersTypes.digitalCuratorship.providerId;
            const scoresRes = await fetchGetAuth(`${window.config.baseApiUrl}/gamification/api/contest/${window.config.contestId}/provider/${digitalCuratorshipProvider}/Assessments`);
            const statisticsRes = await fetchGetAuth(`${window.config.baseApiUrl}/gamification/api/aidigitalcuratorship/ChallengeStatistics`);

            let filteredDataWithScore = res?.map(x => {
                const { score = null, views = 0 } = scoresRes?.find(sr => sr.challengeId === x.challengeId) || {};
                return { ...x, score, views };
            });

            filteredDataWithScore = filteredDataWithScore?.filter(x =>
                x.display &&
                x.language === lang &&
                (!x.superVision || !superVisions?.length ||
                    x.superVision.split(",").some(item => superVisions.includes(parseInt(item)))
                ));

            if (isStudent) {
                const studentClass = parseInt(user.studentkita);
                filteredDataWithScore = filteredDataWithScore.filter(x => !x.isTeacher && x.fromClass <= studentClass && x.toClass >= studentClass);
            }
            else {
                filteredDataWithScore = filteredDataWithScore.filter(x => x.isTeacher &&
                    (
                        userDetails.schools.length === 0 ||
                        userDetails.schools?.some(school => !school.fromClass || !school.toClass) ||
                        userDetails.schools.some(school => x.fromClass <= school.toClass && x.toClass >= school.fromClass)
                    )
                );
            }

            let dataWithStatistics = filteredDataWithScore?.map(x => ({
                ...x,
                filterAIComp: x.filterAIComp ? [...x.filterAIComp?.split(",")] : null,
                classrange: (!x.fromClass && !x.toClass) ? [] : [...Array((x.toClass || x.fromClass) - (x.fromClass || x.toClass) + 1)].map((myclass, i) => String(i + (x.fromClass || x.toClass))),
                tabName: x.tabName?.trim(),
                ...(statisticsRes?.my[x.challengeId] ?? {}),
                ...(statisticsRes?.all[x.challengeId] ?? {})
            }));

            dispatch(assessmentsActions.initDigitalCuratorship(dataWithStatistics));
        }
        catch (e) {
            console.log('error in fetch DigitalCuratorship: ', e);
        }
    }
}

export const initAlbertAssessments = () => {
    return async (dispatch) => {
        try {

            const methodicaProvider = aICompetitionProvidersTypes.methodica.providerId;
            const assessments = await fetchGetAuth(`${window.config.baseApiUrl}/gamification/api/contest/${window.config.contestId}/provider/${methodicaProvider}/Assessments`);
            if (assessments) {
                let myAlbertAssessments = assessments?.reduce((allMyAlbertAssessments, assessment) => {
                    if (window.config.albertAssessments?.includes(assessment.challengeId))
                        allMyAlbertAssessments.push({ ...assessment, complated: assessment.score != null && assessment.score >= 0 });
                    return allMyAlbertAssessments;
                }, []);

                dispatch(assessmentsActions.initAlbertAssessments(myAlbertAssessments));
            }
            else
                dispatch(assessmentsActions.initAlbertAssessments([]));
        }
        catch (e) {
            dispatch(assessmentsActions.initAlbertAssessments([]));
            console.log('error in fetch DigitalCuratorship: ', e);
        }
    }
}

export const setUpdateDigitalView = (challengeId) => {
    return async (dispatch) => {
        try {
            const data = {
                challengeId: challengeId,
                isView: true
            }
            await postJson(`${window.config.baseApiUrl}/gamification/api/aidigitalcuratorship/UpdateChallengeStatistics`, data);
            dispatch(assessmentsActions.updateAssessmentView(challengeId));
        }
        catch (e) {
            console.log('error in fetch setUpdateDigitalView: ', e);
        }
    }
}

export const setUpdateDigitalLike = (challengeId) => {
    return async (dispatch) => {
        try {
            const data = {
                challengeId: challengeId,
                isLike: true
            }
            await postJson(`${window.config.baseApiUrl}/gamification/api/aidigitalcuratorship/UpdateChallengeStatistics`, data);
            dispatch(assessmentsActions.updateDigitalLike(challengeId));
        }
        catch (e) {
            console.log('error in fetch setUpdateDigitalView: ', e);
        }
    }
}